export let tableLabels = [{
  label: '受检人',
  value: ''
}, {
  label: '称谓', // 性别
  value: ''
}, {
  label: '样本条码号',
  value: 'orderActionData.order.currentSample.sampleId'
}, {
  label: '检测套餐',
  value: 'orderActionData.order.clientProduct.name'
}, {
  label: '联系电话',
  value: ''
}, {
  label: '代理商',
  value: ''
}, {
  label: '申请时间',
  value: ''
}, {
  label: '备注',
  value: ''
}]
